import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryCounts_ds_count_tasks_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { inventoryCountId?: number, statusIds?: number[], fullTextSearch?: string, onlyCountsWithDiscrepancies?: boolean, operationCodeIds?: number[], warehouseId?: number[], toDate?: string, fromDate?: string, reasonCodeIds?: number[] }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, Employee?: string, ExpectedPackagedAmount?: number, Notes?: string, ReleaseDateTime?: string, Material?: { Id?: number, LookupCode?: string }, VendorLot?: { Id?: number, LookupCode?: string }, Lot?: { Id?: number, LookupCode?: string }, ExpectedSourceLocation?: { Id?: number, Name?: string, StorageCategory?: { Id?: number, LookupCode?: string } }, ExpectedSourceLicensePlate?: { Id?: number, LookupCode?: string }, Status?: { Id?: number, Name?: string }, OperationCode?: { Id?: number, Name?: string }, ExpectedPackagedPack?: { Id?: number, Name?: string, ShortName?: string }, Project?: { Id?: number, LookupCode?: string, Owner?: { LookupCode?: string } }, InventoryCountDiscrepancies?: { Id?: number, ActualAmount?: number, ExpectedAmount?: number, ResolvedDatetime?: string, StatusId?: number }[], InventoryCountTaskProperty?: { TaskId?: number, InventoryCountId?: number }, ReasonCode?: { Id?: number, Name?: string }, Warehouse?: { Id?: number, Name?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/InventoryCounts/datasources/ds_count_tasks_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { inventoryCountId?: number, statusIds?: number[], fullTextSearch?: string, onlyCountsWithDiscrepancies?: boolean, operationCodeIds?: number[], warehouseId?: number[], toDate?: string, fromDate?: string, reasonCodeIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, Employee?: string, ExpectedPackagedAmount?: number, Notes?: string, ReleaseDateTime?: string, Material?: { Id?: number, LookupCode?: string }, VendorLot?: { Id?: number, LookupCode?: string }, Lot?: { Id?: number, LookupCode?: string }, ExpectedSourceLocation?: { Id?: number, Name?: string, StorageCategory?: { Id?: number, LookupCode?: string } }, ExpectedSourceLicensePlate?: { Id?: number, LookupCode?: string }, Status?: { Id?: number, Name?: string }, OperationCode?: { Id?: number, Name?: string }, ExpectedPackagedPack?: { Id?: number, Name?: string, ShortName?: string }, Project?: { Id?: number, LookupCode?: string, Owner?: { LookupCode?: string } }, InventoryCountDiscrepancies?: { Id?: number, ActualAmount?: number, ExpectedAmount?: number, ResolvedDatetime?: string, StatusId?: number }[], InventoryCountTaskProperty?: { TaskId?: number, InventoryCountId?: number }, ReasonCode?: { Id?: number, Name?: string }, Warehouse?: { Id?: number, Name?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/InventoryCounts/datasources/ds_count_tasks_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { inventoryCountId?: number, statusIds?: number[], fullTextSearch?: string, onlyCountsWithDiscrepancies?: boolean, operationCodeIds?: number[], warehouseId?: number[], toDate?: string, fromDate?: string, reasonCodeIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, Employee?: string, ExpectedPackagedAmount?: number, Notes?: string, ReleaseDateTime?: string, Material?: { Id?: number, LookupCode?: string }, VendorLot?: { Id?: number, LookupCode?: string }, Lot?: { Id?: number, LookupCode?: string }, ExpectedSourceLocation?: { Id?: number, Name?: string, StorageCategory?: { Id?: number, LookupCode?: string } }, ExpectedSourceLicensePlate?: { Id?: number, LookupCode?: string }, Status?: { Id?: number, Name?: string }, OperationCode?: { Id?: number, Name?: string }, ExpectedPackagedPack?: { Id?: number, Name?: string, ShortName?: string }, Project?: { Id?: number, LookupCode?: string, Owner?: { LookupCode?: string } }, InventoryCountDiscrepancies?: { Id?: number, ActualAmount?: number, ExpectedAmount?: number, ResolvedDatetime?: string, StatusId?: number }[], InventoryCountTaskProperty?: { TaskId?: number, InventoryCountId?: number }, ReasonCode?: { Id?: number, Name?: string }, Warehouse?: { Id?: number, Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryCounts/datasources/ds_count_tasks_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      inventoryCountId?: number, statusIds?: number[], fullTextSearch?: string, onlyCountsWithDiscrepancies?: boolean, operationCodeIds?: number[], warehouseId?: number[], toDate?: string, fromDate?: string, reasonCodeIds?: number[]    }) {
      return false;
    }
}
